import React from 'react';
import {View} from 'react-native';
import {Image} from '@rneui/themed';
import {observer} from 'mobx-react';

import {useWebScreenDimensions} from '../../../hooks/useWebScreenDimensions';
import {useStores} from '../../../stores/use-stores';
import { brandRewardsCopy } from '../../../utils/rewards';
import {MemberPriceCarousel} from '../../ProductCarousel';
import TitleLine from '../TitleLine';

type JustForYouProps = {
  onSeeAllPress?: () => void;
};

function JustForYou({onSeeAllPress}: JustForYouProps) {
  const {loyaltyInformationStore} = useStores();

  const {isWebDesktopScreen} = useWebScreenDimensions();

  const imageUri = isWebDesktopScreen
    ? loyaltyInformationStore.information.RewardsPageJustForYou.data
        ?.imageDesktop?.url
    : loyaltyInformationStore.information.RewardsPageJustForYou.data?.image
        ?.url;

  return (
    <View>
      <TitleLine title={`${brandRewardsCopy.memberPrivatePricingTitle.toUpperCase()}`} onSeeAllPress={onSeeAllPress} />
      <Image
        onPress={onSeeAllPress}
        containerStyle={{
          marginBottom: isWebDesktopScreen ? 24 : 10,
          width: '100%',
          aspectRatio: 1.54,
          flex: 1,
          borderRadius: 10,
          ...(isWebDesktopScreen ? {maxHeight: 400} : {}),
        }}
        source={{uri: imageUri}}
      />
      <MemberPriceCarousel member_price="private" />
    </View>
  );
}

export default observer(JustForYou);
